export default "__VITE_ASSET__CMZhVuyw__"